import React from "react";
import PropTypes from "prop-types";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import { Box, Typography } from "@mui/material";
import calendaricon from "../../assets/images/calendaricon.svg";
import InfoIcon from "../../components/general/infoIcon"


export const widgetDatePrototype = [
        {
          "key": "infotext",
          "type": "STRING",
          "label": "infotext",
          "size": 6
        }
      ]

const momentToIsoDate = mom => mom.format("YYYY-MM-DD")

const DatePicker = ({
    widget,
    onValueChange,
    onBlur,
    selectOnFocus,
    onFocus,
    value,
    disabled,
    className,
    label,
    id,
    error,
    triggerAction
}) => {

    const localOnChange = momentObj => {
        if (onValueChange) {
            momentObj?.isValid()
                ? onValueChange(momentToIsoDate(momentObj))
                : onValueChange(null, el => el, [])
        }
    }

    const localOnBlur = event => {
        if (onBlur) {
            onBlur(moment(event.target.value, "DD.MM.YYYY"), momentToIsoDate)
        }
    }

    const localOnFocus = event => {
        if (selectOnFocus) {
            event.target.select()
        }
        if (onFocus) {
            onFocus(event)
        }
    }
    return (
        <Box>
            {widget.text && (
                <Box display="flex" alignItems="center">
                    <Typography className={disabled ? "disabled" : ""}>
                        {widget.text}
                    </Typography>
                </Box>
            )}
            <Box display="flex" alignItems="center">

                <DesktopDatePicker
                label={label}
                id={id}
                value={value ? moment(value) : null}
                onChange={localOnChange}
                onBlur={localOnBlur}
                onFocus={localOnFocus}
                disabled={disabled}
                className={className}
                views={["year", "month", "day"]}
                slots={{
                    openPickerIcon: calendaricon,
                }}
                slotProps={{
                    textField: {
                        error: error,
                    },
                }}
        ><InfoIcon infoText={widget.infotext} />
            </DesktopDatePicker>
                <InfoIcon infoText={widget.infotext} />
        </Box>
        </Box>
    )
}

DatePicker.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func,
    key: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
}

export default DatePicker

